export const NON_DISCOUNTABLE_CATEGORIES = ['podarunkovi-sertifikati'];
